import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data: {
    isApprove: boolean;
    id: string;
    warning: string | null;
  };
}

const initialState: InitialState = {
  status: ReduxStateType.LOADING,
  data: {
    isApprove: true,
    id: "",
    warning: null,
  },
};

const handleRequestSlice = createSlice({
  name: "handleRequestSlice",
  initialState,
  reducers: {
    setupDataRequest: (state, action) => {
      state.status = ReduxStateType.LOADING;
      state.data = action.payload;
    },
    handleRequestStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    handleRequestSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
    },
    handleRequestFailed: (state, action) => {
      state = {
        ...initialState,
      };
    },
  },
});

export const {
  setupDataRequest,
  handleRequestStart,
  handleRequestSuccess,
  handleRequestFailed,
} = handleRequestSlice.actions;

export default handleRequestSlice.reducer;
